var map = {
	"./adtraction-logo.png": "5f87",
	"./advisa-logo.png": "b84d",
	"./anmarkning-logo.png": "31f6",
	"./axo-finans-logo.png": "ef91",
	"./bank-norwegian-logo.png": "eba9",
	"./brixo-logo.png": "5488",
	"./cashbuddy-logo.png": "1b10",
	"./comboloan-logo.png": "748e",
	"./compari-logo.png": "1b66",
	"./compricer-logo.png": "a5d9",
	"./coop-medmera-bank-logo.png": "6005",
	"./credway-logo.png": "2e1b",
	"./direkto-logo.png": "6d92",
	"./enklare-logo.png": "584f",
	"./everydayplus-logo.png": "3a4c",
	"./expresskredit-logo.png": "7384",
	"./fairlo-logo.png": "91f0",
	"./favoritlan-logo.png": "6e07",
	"./ferratum-logo.png": "10a6",
	"./flexkontot-logo.png": "1dc8",
	"./flexlimit-logo.png": "ac51",
	"./freedomfinance-logo.png": "76b3",
	"./frogtail-logo.png": "5b3b",
	"./gfmoney-logo.png": "5c74",
	"./goodcash-logo.png": "ee53",
	"./klaralan-logo.png": "e8e4",
	"./klicklan-logo.png": "6821",
	"./kontantfinans-logo.png": "0047",
	"./kredit365-logo.png": "aff9",
	"./kundfinans-logo.png": "43b0",
	"./lanekoll-logo.png": "c8fa",
	"./leasy-logo.png": "286d",
	"./lendo-logo.png": "e654",
	"./letalan-logo.png": "b38a",
	"./likvidum-logo.png": "6be1",
	"./lsb-logo.png": "29bf",
	"./lumify-logo.png": "270e",
	"./meddelandelan-logo.png": "9d54",
	"./merax-logo.png": "a3d4",
	"./moank-logo.png": "b033",
	"./mobillan-logo.png": "3a1c",
	"./monara-logo.png": "2a82",
	"./monetti-logo.png": "c38a",
	"./natlan-logo.png": "ccc4",
	"./northmill-logo.png": "077e",
	"./pluskan-logo.png": "fedf",
	"./profilkredit-logo.png": "2090",
	"./ratsit-logo.png": "f79f",
	"./sakerfinans-logo.png": "691d",
	"./sevenday-logo.png": "75a9",
	"./slantar-logo.png": "2c9c",
	"./smspengar-logo.png": "47e5",
	"./snabbfinans-logo.png": "da04",
	"./spargo-logo.png": "b4a7",
	"./svea-logo.png": "78ae",
	"./tando-logo.png": "26f5",
	"./thorn-logo.png": "6e4e",
	"./uc-logo.png": "7f62",
	"./viaconto-logo.png": "3ee3",
	"./viiga-logo.png": "104f",
	"./wastgota-logo.png": "0ceb",
	"./zmarta-logo.png": "1908"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";